
import { defineComponent } from "vue";
import IconChevronRight from "~icons/tabler/chevron-right";
import IconMapPin from "~icons/tabler/map-pin";
import Divider from "primevue/divider";
import { FeedbackItem } from "@/typings/FeedbackItem";
import FeedbackTypeIcon from "./FeedbackTypeIcon.vue";

export default defineComponent({
  name: "PublicFeedback",
  props: {
    feedback: {
      type: Object as () => FeedbackItem,
      required: true,
    },
  },
  computed: {
    feedbackLocale() {
      if (!this.feedback.type) {
        return "";
      }

      return this.$t(`feedback.${this.feedback.type.name}`);
    },
  },
  components: {
    IconChevronRight,
    IconMapPin,
    Divider,
    FeedbackTypeIcon,
  },
});
